// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"9f0ff194","328":"d92b237b","396":"00b6e7d7"}[chunkId] + ".chunk.js";
};